import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Certificate01 = function Certificate01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.5 20H5c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h14c1.1046 0 2 .8954 2 2v14c0 1.1046-.8954 2-2 2h-1.5M12 19c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m0 0 .0214-.0002-3.1927 3.1928-2.8285-2.8285 3.0195-3.0194M12 19l3.1928 3.1926 2.8284-2.8285-3.0194-3.0194M9 6h6M7 9.5h10"
    })
  }));
};
export default Certificate01;